module.exports = __webpack_public_path__ + "static/media/Sham-Gir.37375b83.png";